import { render, staticRenderFns } from "./DocumentMenu.vue?vue&type=template&id=614baade&scoped=true"
import script from "./DocumentMenu.vue?vue&type=script&lang=js"
export * from "./DocumentMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614baade",
  null
  
)

export default component.exports